import { getFansLeaderboardPosition } from '@/features/fans-leaderboard/api/fansLeaderboardPositionApi'
import { createQueryHook } from '@/shared/api'
import { useAuthStore } from '@/stores/authStore'

export const enum FansLeaderboardPositionQueryKeys {
  POSITION = 'fans_leaderboard_position'
}

const useFansLeaderboardPositionFactory = createQueryHook<
  { sportType?: string; clubId?: string; enabled: boolean },
  Awaited<ReturnType<typeof getFansLeaderboardPosition>>
>({
  getQueryKey: ({ sportType, clubId }) => [
    FansLeaderboardPositionQueryKeys.POSITION,
    sportType ?? 'all',
    clubId ?? 'global'
  ],
  queryFn: ({ sportType, clubId }) =>
    getFansLeaderboardPosition({ sportType, clubId }),
  getEnabled: ({ enabled }) => enabled,
  getOptions: () => ({ retry: false, staleTime: 30_000 })
})

/** The signed-in fan's rank on the global, sport or club board. */
export function useFansLeaderboardPosition(
  sportType?: string,
  clubId?: string,
  enabled = true
) {
  const isAuthenticated = useAuthStore(s => s.isAuthenticated)

  return useFansLeaderboardPositionFactory({
    sportType,
    clubId,
    enabled: enabled && isAuthenticated
  })
}
